import { useMutation } from "@tanstack/react-query";
import { EndPoints } from "../../../Constants/endpoints";
import { GeneralResponse } from "../../../interface/GeneralResponse";
import Api from "../../generalApi/Api";
import { Methods } from "../../../Constants/ApiConstants";
import { useParams } from "react-router-dom";
export interface VerifyCodeForgetPasswordRequest {
  Id: null | number;
  VerificationCode: string;
}

export const useVerifyCode = () => {
  const { setting } = useParams();
  const mutation = useMutation({
    mutationFn: (
      data: VerifyCodeForgetPasswordRequest,
    ): Promise<GeneralResponse> => {
      return Api<VerifyCodeForgetPasswordRequest, GeneralResponse>({
        method: Methods.POST,
        endpoint:
          setting === "setting"
            ? EndPoints.ForgetPasswordCheckCodeLogedIn
            : EndPoints.ForgetPasswordCheckCode,
        body: data,
      });
    },
    onSuccess: (data) => {
      return data;
    }, 
  });

  return mutation;
};
